import React from "react"
import { Card, CardBody } from "reactstrap"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import GeneralTables from "components/Common/GeneralTable"
import ActionColumns from "components/Common/GeneralTable/ActionColumns"

const FundCodeListComponent = ({
  data,
  loading,
  onClickDelete,
  onPageClick,
  onSearch,
  onChangeRowNumber,
  onChangeOrdering,
  onExportBtnClick,
  exportStatus,
}) => {
  return (
    <Card>
      <CardBody>
        <CustomHeaderTitle
          loading={loading}
          title={"List"}
          rowCount={true}
          onChangeRowNumber={onChangeRowNumber}
          orderingList={true}
          onChangeOrdering={onChangeOrdering}
          searchBox={true}
          onSearchHandler={onSearch}
          exportBtn={true}
          onExportBtnClick={onExportBtnClick}
          exportBtnLoading={exportStatus?.loading}
          rightBtn={true}
          rightBtnTitle={"Add Fund Code"}
          rightBtnRoute={"/add-fund-code"}
          orderingOptions={[
            { value: "id", name: "ID" },
            { value: "code", name: "Code" },
            { value: "name", name: "Name" },
            { value: "status", name: "Status" },
          ]}
        />

        <GeneralTables
          data={data?.data}
          loading={loading}
          headers={["#", "Code", "Name", "Status", "Action"]}
          pagination={{ meta: data?.meta, onPageClick: onPageClick }}
          renderItem={(record, index) => (
            <tr key={record.id}>
              <th scope="row">{data?.meta?.from + index}</th>
              <td>{record.code}</td>
              <td>{record.name}</td>
              <td>{record.status}</td>
              <td>
                <ActionColumns
                  data={record}
                  enableEdit={true}
                  enableDelete={true}
                  editRoute={`/edit-fund-code/${record.id}`}
                  onClickDelete={onClickDelete}
                />
              </td>
            </tr>
          )}
        />
      </CardBody>
    </Card>
  )
}

export default FundCodeListComponent
